import {
  differenceInDays,
  endOfDay,
  endOfMonth,
  endOfWeek,
  isSameDay,
  isSameMonth,
  isSameWeek,
  startOfDay,
  startOfMonth,
  startOfWeek,
  subDays,
  subWeeks,
} from 'date-fns'
import { WeekStartsOn } from '@opallabs/concepts'

export const startModeFunctions = {
  day: startOfDay,
  week: startOfWeek,
  month: startOfMonth,
} as const

export const endModeFunctions = {
  day: endOfDay,
  week: endOfWeek,
  month: endOfMonth,
} as const

export const sameModeFunctions = {
  day: isSameDay,
  week: isSameWeek,
  month: isSameMonth,
} as const

export const dateFromDayIndex = (
  numberOfDays: number,
  dayIndex: number,
  day: Date
) => {
  const middleDay = Math.floor(numberOfDays / 2)
  const dayOffset = middleDay - dayIndex
  const date = subDays(day, dayOffset)
  return date
}

export const dateFromWeekIndex = (
  numberOfWeeks: number,
  weekIndex: number,
  day: Date
) => {
  const middleWeek = Math.floor(numberOfWeeks / 2)
  const weekOffset = middleWeek - weekIndex
  const date = subWeeks(day, weekOffset)
  return date
}

export const startOfWeekByDay = (
  numberOfWeeks: number,
  weekNumber: number,
  day: Date,
  weekStartsOn: WeekStartsOn = WeekStartsOn.Sunday
) => {
  const middleWeek = parseInt((numberOfWeeks / 2).toFixed(0), 10)
  const weekOffset = middleWeek - weekNumber
  const start = startOfWeek(subWeeks(day, weekOffset), {
    weekStartsOn,
  })
  return start
}

export const getDayIndexFromDate = (date: Date, dayCount: number) => {
  const daysDiff = differenceInDays(date, new Date())
  return dayCount / 2 + daysDiff
}

export const getWeekIndexFromDate = (date: Date, weekCount: number) => {
  const daysDiff = differenceInDays(date, new Date())
  const weeksDiff = Math.ceil(daysDiff / 7)
  return weekCount / 2 + weeksDiff
}

export const getIndexFromScrollOffset = (offset: number, unitWidth: number) => {
  const initialIndex = offset / unitWidth
  return Math.ceil(initialIndex)
}

export const getWeekIndexFromScrollOffset = (
  offset: number,
  weekWidth: number
) => {
  const initialIndex = offset / weekWidth
  return Math.ceil(initialIndex)
}
